<template>
    <div>
        <rkm-form
            ref="Form"
        >
            <rkm-row>

                <rkm-col
                    cols="12"
                >
                    <rkm-area
                        title="Unidade destino"
                        type="fieldset"
                    >

                        <rkm-row>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    :options="unidades"
                                    :validations="validations.unidade"
                                    label="Unidade"
                                    show-default-option
                                    text-field="nomeFantasia"
                                    v-model="unidadeDestino.unidadeId"
                                    :disabled="!unidadeDisabled"
                                    value-field="unidadeId"
                                    @change="handleBlurDestino"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    label="Local de atendimento"
                                    :options="infraestruturasDestino"
                                    :validations="validations.infraestrutura"
                                    textField="nome"
                                    v-model="unidadeDestino.infraestruturaId"
                                    :disabled="!unidadeDestino.unidadeId"
                                    valueField="id"
                                    show-default-option
                                    @change="resetUnidadeDestino"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row class="flex-nowrap">
                            <rkm-col class="flex-grow-1">
                                <rkm-form-select
                                    :options="data.form.tipo"
                                    label="Tipo"
                                    show-default-option
                                    text-field="descricao"
                                    v-model="origem.cotaTipoId"
                                    value-field="id"
                                    :validations="validations.tipo"
                                    disabled

                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-date-picker
                                    label="Início"
                                    v-model="unidadeDestino.inicio"
                                    :validations="validations.inicio"
                                    :disabled="!unidadeDestino.infraestruturaId"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-date-picker
                                    label="Fim"
                                    v-model="unidadeDestino.fim"
                                    disabled
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>

            <rkm-row v-show="this.cotaUnidade && cotaOrigem">

                <rkm-col
                    cols="12"
                >
                    <rkm-area
                        title="Transferência de cota livre"
                        type="fieldset"
                    >

                        <rkm-row>

                            <rkm-col class="flex-grow-1" v-show="origem.cotaTipoId == enums.tipoCota.QUANTIDADE">
                                <rkm-form-input
                                    label="Saldo"
                                    v-model="origem.cotaQuantidade"
                                    :validations="unidade.cotaTipoId == enums.tipoCota.QUANTIDADE ? validations.cotaQuantidade : {}"
                                    number
                                    disabled
                                />
                            </rkm-col>

                            <rkm-col class="flex-grow-1" v-show="origem.cotaTipoId != enums.tipoCota.QUANTIDADE">
                                <rkm-form-input
                                    label="Saldo"
                                    ref="cotaValor"
                                    v-model="unidade.cotaValor"
                                    :validations="origem.cotaTipoId == enums.tipoCota.VALOR ? validations.cotaValor : {}"
                                    v-money="money"
                                    prepend="R$"
                                    disabled
                                />
                            </rkm-col>

                            <rkm-col class="flex-grow-1" v-show="origem.cotaTipoId == enums.tipoCota.QUANTIDADE">
                                <rkm-form-input
                                    label="Quantidade"
                                    v-model="unidadeDestino.cotaQuantidade"
                                    :disabled="!unidadeDestino.fim"
                                    number
                                />
                            </rkm-col>

                            <rkm-col class="flex-grow-1" v-show="origem.cotaTipoId != enums.tipoCota.QUANTIDADE">
                                <rkm-form-input
                                    label="Valor"
                                    ref="cotaValorDestino"
                                    v-model="unidadeDestino.cotaValor"
                                    :disabled="!unidadeDestino.fim"
                                    v-money="money"
                                    prepend="R$"
                                />
                            </rkm-col>

                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="transferenciaLaboratorio && this.verifyExame && this.examesOrigem">

                <rkm-col
                    cols="12"
                >
                    <rkm-area
                        title="Transferência de exames atribuídos"
                        type="fieldset"
                    >

                        <rkm-table
                            :fields="fields"
                            :items="dados"
                            ref="Table"
                        >

                            <template v-slot:cell(consumido)>
                                {{ consumido }}
                            </template>

                            <template v-slot:cell(transferir)="{ item }">

                                <rkm-form-input
                                    v-show="origem.cotaTipoId == enums.tipoCota.QUANTIDADE"
                                    v-model="item.cotaQuantidadeTransferido"
                                    number
                                />

                                <rkm-form-input
                                    v-show="origem.cotaTipoId !== enums.tipoCota.QUANTIDADE"
                                    v-model="item.cotaValorTransferido"
                                    v-money="money"
                                    prepend="R$"
                                />
                            </template>

                        </rkm-table>
                    </rkm-area>
                </rkm-col>
            </rkm-row>

            <rkm-row>

                <rkm-col
                    cols="12"
                >
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click.stop="$refs.Form.validate(add)"
                        class="mt-0 float-right"
                    >
                        {{ checkHandleAlter ? 'Alterar' : 'Incluir' }}
                    </rkm-button>

                    <rkm-button
                        v-if="checkHandleAlter"
                        :label="false"
                        color="secondary"
                        @click.stop="hideAlter()"
                        class="mt-0 mr-2 float-right"
                    >
                        Voltar
                    </rkm-button>

                    <rkm-button
                        v-else
                        :label="false"
                        color="secondary"
                        @click.stop="hideAlter()"
                        class="mt-0 mr-2 float-right"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <List
            v-if="!checkHandleAlter"
            :data="data"
            :unidadeId="origem.unidadeId"
            :infraestruturaId="origem.infraestruturaId"
            :laboratorioUnidadeId="laboratorio.unidadeId"
            :laboratorioInfraestruturaId="laboratorio.infraestruturaId"
            :cotaUnidadeSolicitante="cotaUnidadeSolicitante"
            :transferenciaLaboratorio="transferenciaLaboratorio"
            @handleAlter="handleAlter"
        />

    </div>
</template>


<script>
// Mixins.
import { object, data, formats } from '@/mixins'

// Components.
import List from './List'

// Enums.
import tipoCota from '@/enums/exame-laboratorial/tipoCota'
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'

//Directives
import { VMoney } from 'v-money'

// Moment.
import moment from 'moment'

export default {
    directives: { money: VMoney },
    mixins: [ object, data, formats ],
    components: { List },
    computed: {
        validations() {

            return {
                observacao: { max: 500 },
                cotaValor: { max: 13, min_value: 0.01 },
                cotaQuantidade: { min_value: 1, required: true },
                tipo: { required: true },
                inicio: { required: true },
            }
        },
        hasIndex() {

            return this.index !== null
        },
        maxDate() {

            if (this.unidade.periodo.start) {

               return moment(this.getFormatedDate(this.unidade.periodo.start, 'YYYY-MM-DD')).endOf("month").format('DD-MM-YYYY')
            }

            return null
        },
        minDate() {

            if (this.unidade.periodo.end) {

               return moment(this.getFormatedDate(this.unidade.periodo.end, 'YYYY-MM-DD')).startOf("month").format('DD-MM-YYYY')
            }

            return null
        },
        infraestruturasDestino() {

            if (this.unidadeDestino.unidadeId) {

                let infraestruturaPrincipal = this.UnidadeSolicitanteOrigem.find(u => u.unidadeId === this.unidadeDestino.unidadeId).infraestruturas

                if (!this.checkHandleAlter) {

                    this.getPrincipalDestino(infraestruturaPrincipal)
                }

                return infraestruturaPrincipal
            }

            return []
        },
        fields() {

            const fields = [
                {
                    key: 'nome',
                    label: 'Exame',
                    sortable: true
                },
                {
                    key: 'cota',
                    label: 'Cota',
                    sortable: true
                },
                {
                    key: 'consumido',
                    label: 'Utilizada',
                    sortable: true
                },
                {
                    key: 'transferencia',
                    label: 'Transferência enviada',
                    sortable: true
                },
                {
                    key: 'transferenciaRecebida',
                    label: 'Transferência recebida',
                    sortable: true
                },
                {
                    key: 'saldo',
                    label: 'Saldo',
                    sortable: true
                },
                {
                    key: 'transferir',
                    label: 'Transferir',
                    class: 'col-3',
                    sortable: true
                },
            ]

            return fields
        },
        dados() {

            let items = this.exames.filter(solicitante => solicitante.unidadeSolicitante.length > 0)
                .map(unidade => {

                    let transferencia = this.getCotaExame(unidade.exameId)
                    let saldo = 0
                    let transferenciaRecebida = 0

                    if (this.origem.cotaTipoId == this.enums.tipoCota.VALOR) {

                        transferencia = this.formatMoney(transferencia,2)

                        if (unidade.transferido) {

                            let ValorTransferido = this.formatMoney(unidade.transferido,2)
                            transferencia =  this.formatSumMoney(transferencia) - this.formatSumMoney(ValorTransferido)
                            transferencia = this.formatMoney(transferencia,2)
                        }

                    } else {

                        transferencia = transferencia - unidade.transferido
                    }

                    let transferenciaLaboratorio = this.data.model.cotasTransferencia.filter(field =>
                        field.unidadeTipoId == this.enums.tipoUnidade.LABORATORIO
                        && field.laboratorioUnidadeId == this.laboratorio.unidadeId
                        && field.laboratorioInfraestruturaId == this.laboratorio.infraestruturaId
                    )

                    if (transferenciaLaboratorio.length > 0) {

                        transferenciaLaboratorio = transferenciaLaboratorio.map(field2 => field2.destino)

                        Object.keys(transferenciaLaboratorio).forEach(a => {

                            let recebidos = transferenciaLaboratorio[a]
                                .filter(i => i.destinoUnidadeId == this.origem.unidadeId
                                    && i.destinoInfraestruturaId == this.origem.infraestruturaId
                                    && i.origemCotaTipoId == this.origem.cotaTipoId
                                    && moment(
                                        this.getFormatedDate(this.origem.inicio, 'YYYY-MM-DD')
                                    )
                                    .isBetween(
                                        i.destinoInicio.split("/").reverse().join("-"),
                                        i.destinoFim.split("/").reverse().join("-"),
                                        null,
                                        '[]'
                                    )

                                    || i.destinoUnidadeId == i.destinoUnidadeId == this.origem.unidadeId
                                    && i.destinoInfraestruturaId == this.origem.infraestruturaId
                                    && i.origemCotaTipoId == this.origem.cotaTipoId
                                        && moment(
                                        this.getFormatedDate(this.origem.fim, 'YYYY-MM-DD')
                                        )
                                        .isBetween(
                                            i.destinoInicio.split("/").reverse().join("-"),
                                            i.destinoFim.split("/").reverse().join("-"),
                                            null,
                                            '[]'
                                        )
                                )

                            recebidos.forEach(v => {

                                if (this.origem.cotaTipoId == this.enums.tipoCota.VALOR) {

                                    transferenciaRecebida = this.formatMoney(transferenciaRecebida, 2)

                                    if (this.getExameRecebido(v)) {

                                        transferenciaRecebida = this.formatSumMoney(transferenciaRecebida) +
                                            this.formatSumMoney(this.getExameRecebido(v, unidade))

                                    }

                                    transferenciaRecebida = this.formatMoney(transferenciaRecebida, 2)

                                } else {

                                    transferenciaRecebida = transferenciaRecebida + this.getExameRecebido(v, unidade)
                                }
                            });
                        })
                    }

                    let unidadeSolicitante = unidade.unidadeSolicitante.find((obj =>
                        obj.unidadeSolicitanteId == this.origem.unidadeId
                        && obj.infraestruturaSolicitanteId == this.origem.infraestruturaId
                    ))

                    if (unidadeSolicitante) {

                        if (this.origem.cotaTipoId == this.enums.tipoCota.VALOR) {

                            saldo = this.formatMoney(unidadeSolicitante.cota,2)
                            transferenciaRecebida = this.formatMoney(transferenciaRecebida,2)

                            saldo =  (this.formatSumMoney(saldo) - this.formatSumMoney(transferencia))
                                + this.formatSumMoney(transferenciaRecebida)
                            saldo = this.formatMoney(saldo,2)

                        } else {

                            saldo = (unidadeSolicitante.cota - transferencia) + transferenciaRecebida
                        }

                        return {
                            cota: unidadeSolicitante.cota,
                            cotaExamePeriodoId: unidade.cotaExamePeriodoId,
                            cotaQuantidade: unidadeSolicitante.cotaQuantidade,
                            cotaQuantidadeTransferido: unidade.cotaQuantidadeTransferido,
                            cotaValor: unidadeSolicitante.cotaValor,
                            cotaValorTransferido: unidade.cotaValorTransferido,
                            exameId: unidade.exameId,
                            nome: unidade.nome,
                            unidadeSolicitante: unidade.unidadeSolicitante,
                            transferencia: transferencia,
                            transferenciaRecebida: transferenciaRecebida,
                            transferido: unidade.transferido,
                            saldo: saldo,
                        }
                    }

                    return null
                })

            return items.filter(item => item !== null);
        }
    },
    methods: {
        add() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                        if (this.origem.cotaTipoId == this.enums.tipoCota.VALOR) {

                            if (this.formatSumMoney(this.unidadeDestino.cotaValor) >
                                this.formatSumMoney(this.unidade.cotaValor)) {

                                    this.showValidationNotification(`O valor da transferência não deve ultrapassar o saldo.`)

                                    return false
                            }

                            let msg = ''

                            this.dados.forEach(e => {

                                if (this.formatSumMoney(e.cotaValorTransferido) > this.formatSumMoney(e.saldo)) {

                                    e.cotaValorTransferido = e.transferido

                                    if (!msg) {

                                        msg = msg.concat(`O valor de transferência do(s) seguinte(s) exame(s) está maior que o
                                            saldo: ${e.nome}`)
                                    } else {

                                        msg = msg.concat(', ', e.nome)
                                    }

                                } else {

                                    e.transferido = e.cotaValorTransferido
                                }

                            })

                            if (msg) {

                                this.showValidationNotification(`${msg}.`)

                                return false
                            }

                            this.unidade.cotaTipoNome = 'Valor'
                        } else {

                            if (Number(this.unidadeDestino.cotaQuantidade) > this.origem.cotaQuantidade){

                                this.showValidationNotification(`O valor da transferência não deve ultrapassar o saldo.`)

                                return false
                            }

                            let msg = ''

                            this.dados.forEach(e => {

                               if (Number(e.cotaQuantidadeTransferido) > Number(e.saldo)){

                                    e.cotaQuantidadeTransferido = e.transferido

                                    if (!msg) {

                                        msg = msg.concat(`O valor de transferência do(s) seguinte(s) exame(s) está maior que o
                                            saldo: ${e.nome}`)
                                    } else {

                                        msg = msg.concat(', ', e.nome)
                                    }

                                } else {

                                    e.transferido = e.cotaQuantidadeTransferido
                                }

                            })

                            if (msg) {

                                this.showValidationNotification(`${msg}.`)

                                return false
                            }

                            this.unidade.cotaTipoNome = 'Quantidade'
                        }

                        const unidade = this.data.form.unidades.find(u => u.id === this.unidadeDestino.unidadeId)
                        const infraestrutura = this.infraestruturasDestino.find(u => u.id === this.unidadeDestino.infraestruturaId)

                        if (!this.unidade.id) {
                            this.unidadeDestino.id = this.uniqueId('destino' + new Date().getTime())
                        }

                        const param = {
                            id: this.unidadeDestino.id,
                            cotaId: this.origem.cotaId,
                            origemUnidadeId: this.origem.unidadeId,
                            origemInfraestruturaId: this.origem.infraestruturaId,
                            origemCotaTipoId: this.origem.cotaTipoId,
                            origemCotaTipoNome: this.unidade.cotaTipoNome,
                            origemCotaValor: this.unidade.cotaValor,
                            origemCotaQuantidade: this.origem.cotaQuantidade,
                            origemInicio: this.getFormatedDate(this.origem.inicio, 'DD/MM/YYYY'),
                            origemFim: this.getFormatedDate(this.origem.fim, 'DD/MM/YYYY'),
                            destinoUnidadeId: this.unidadeDestino.unidadeId,
                            destinoNomeFantasia: unidade.nomeFantasia,
                            destinoInfraestruturaId: this.unidadeDestino.infraestruturaId,
                            destinoInfraestruturaNome: infraestrutura.nome,
                            destinoCotaQuantidade: this.unidadeDestino.cotaQuantidade,
                            destinoCotaValor: this.unidadeDestino.cotaValor,
                            destinoInicio: this.getFormatedDate(this.unidadeDestino.inicio, 'DD/MM/YYYY'),
                            destinoFim: this.getFormatedDate(this.unidadeDestino.fim, 'DD/MM/YYYY'),
                            exames: this.dados
                        }

                        if (this.index !== null) {

                            const objIndex = this.cotaUnidadeSolicitante.findIndex((obj => obj.id == this.model.id));

                            this.$set(this.cotaUnidadeSolicitante, objIndex, this.clone(param))
                        }
                        else {

                            this.cotaUnidadeSolicitante.push(this.clone(param))
                        }

                        this.unidadeDestino.unidadeId = null
                        this.unidadeDestino.infraestruturaId = null
                        this.checkHandleAlter = false
                        this.index = null

                        this.$emit('save')

                        this.resetUnidadeDestino()
                })
        },
        resetForm() {

            this.index = null
            this.unidade.cotaValor = null
            this.$refs.cotaValor.$el.getElementsByTagName('input')[0].value = 0;

            this.unidadeDestino.id = null
            this.unidadeDestino.unidadeId = null
            this.unidadeDestino.infraestruturaId = null
            this.unidadeDestino.cotaTipoId = null
            this.unidadeDestino.unidadeTipoId = ''
            this.unidadeDestino.cotaQuantidade = null
            this.unidadeDestino.inicio = null
            this.unidadeDestino.fim = null
            this.unidadeDestino.cotaValor = null
            this.$refs.cotaValorDestino.$el.getElementsByTagName('input')[0].value = 0;

            this.$emit('resetForm')

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        handleAlter(index, item) {

            this.resetForm()

            this.index = index

            this.model.id = item.id
            this.unidadeDestino.unidadeId = item.destinoUnidadeId
            this.unidadeDestino.infraestruturaId = item.destinoInfraestruturaId
            this.unidadeDestino.cotaQuantidade = item.destinoCotaQuantidade

            this.$refs.cotaValorDestino.$el.getElementsByTagName('input')[0].value = item.destinoCotaValor;

            this.unidadeDestino.inicio= moment(
                item.destinoInicio,
                'DD/MM/YYYY'
            ).toDate()

            this.checkHandleAlter = true

            this.$emit('handleAlter', item)
        },
        hideAlter() {

            this.checkHandleAlter = false

            this.$emit('handleHideLaboratorio', false)

            this.resetForm()
        },
        getPrincipalDestino(infraestruturaPrincipal) {

            this.unidadeDestino.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
        },
        handleBlur() {

            if (!this.unidade.unidadeId) {

                this.unidade.infraestruturaId = null
                this.unidadeDestino.unidadeId = null
                this.unidadeDestino.infraestruturaId = null

                this.resetUnidadeOrigem()
            }
        },
        handleBlurDestino() {

            if (!this.unidadeDestino.unidadeId) {

                this.unidadeDestino.infraestruturaId = null

                this.resetUnidadeDestino()
            }
        },
        resetUnidadeDestino() {

            this.unidadeDestino.id = null
            this.unidadeDestino.unidadeTipoId = ''
            this.unidadeDestino.cotaQuantidade = null
            this.unidadeDestino.inicio = null
            this.unidadeDestino.fim = null
            this.unidadeDestino.cotaValor = null
            this.$refs.cotaValorDestino.$el.getElementsByTagName('input')[0].value = 0;

            this.checkHandleAlter = false

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        getCotaExame(item) {

            let totalTranferenciaQuantidade = 0
            let totalTranferenciaValor = 0

                let recebidos = this.cotaUnidadeSolicitante
                    .filter(i => i.origemUnidadeId == this.origem.unidadeId
                        && i.origemInfraestruturaId == this.origem.infraestruturaId
                        && i.origemCotaTipoId == this.origem.cotaTipoId
                        && moment(
                            this.getFormatedDate(this.origem.inicio, 'YYYY-MM-DD')
                        )
                        .isBetween(
                            i.origemInicio.split("/").reverse().join("-"),
                            i.origemFim.split("/").reverse().join("-"),
                            null,
                            '[]'
                        )

                        || i.origemUnidadeId == this.origem.unidadeId
                            && i.origemInfraestruturaId == this.origem.infraestruturaId
                            && i.origemCotaTipoId == this.origem.cotaTipoId
                            && moment(
                                this.getFormatedDate(this.origem.fim, 'YYYY-MM-DD')
                            )
                            .isBetween(
                                i.origemInicio.split("/").reverse().join("-"),
                                i.origemFim.split("/").reverse().join("-"),
                                null,
                                '[]'
                            )
                    )

                recebidos.forEach(v => {

                    let cotaExame = 0

                    if (v.origemCotaTipoId == this.enums.tipoCota.VALOR) {

                        cotaExame = v.exames.reduce((sum, element) => {

                            if (element.transferido && element.exameId == item) {
                                sum = sum + this.formatSumMoney(element.transferido);
                            }

                            return sum;
                        },0)

                        totalTranferenciaValor = this.formatMoney(totalTranferenciaValor,2)
                        cotaExame = this.formatMoney(cotaExame,2)

                        totalTranferenciaValor =  this.formatSumMoney(totalTranferenciaValor) +  this.formatSumMoney(cotaExame)
                        totalTranferenciaValor = this.formatMoney(totalTranferenciaValor,2)

                    } else {

                        cotaExame = v.exames.reduce((sum, element) => {

                            if (element.transferido && element.exameId == item) {
                                sum = sum + Number(element.transferido);

                            }

                            return sum;
                        },0)

                        totalTranferenciaQuantidade = totalTranferenciaQuantidade + cotaExame
                    }
            });

            if (this.origem.cotaTipoId == this.enums.tipoCota.VALOR) {

                return totalTranferenciaValor
            } else {

                return totalTranferenciaQuantidade
            }
        },
        getExameRecebido(item, unidade) {

            let cotaExame = 0

            if (item.origemCotaTipoId == this.enums.tipoCota.VALOR) {

                 cotaExame = item.exames.reduce((sum, element) => {

                    if (element.transferido && element.exameId == unidade.exameId) {
                        sum = sum + this.formatSumMoney(element.transferido);
                    }

                    return sum;
                },0)

                if (cotaExame) {

                    return this.formatMoney(cotaExame, 2)
                }

            } else {

                cotaExame = item.exames.reduce((sum, element) => {

                    if (element.transferido && element.exameId == unidade.exameId) {
                        sum = sum + Number(element.transferido);
                    }

                    return sum;
                },0)

                return cotaExame
            }
        }
    },
    props: {
        data: { type: Object, required: true },
        cotaUnidadeSolicitante: { type: Array, required: true },
        exames: { type: Array, required: true },
        origem: { type: Object, required: true },
        cotasLaboratorio: { type: Array, required: true },
        laboratorio: { type: Object, required: true },
        unidades: { type: Array, required: true },
        UnidadeSolicitanteOrigem: { type: Array, required: true },
        unidadeDisabled: { type: Boolean, default: false },
        cotaOrigem: { type: Boolean, default: false },
        examesOrigem: { type: Boolean, default: false },
        transferenciaLaboratorio: { type: Boolean, default: false },
    },
    data: () => ({
        form: {
            unidades: {}
        },
        model: {
            id: null,
            index: null,
        },
        cotaTranferencia: [],
        unidade: {
            id: null,
            unidadeId: null,
            infraestruturaId: null,
            cotaTipoId: null,
            cotaTipoNome: null,
            cotaValor: '',
            cotaQuantidade: '',
            saldo: '',
            inicio: null,
            fim: null,
        },
        unidadeDestino: {
            id: null,
            unidadeId: null,
            infraestruturaId: null,
            cotaTipoId: null,
            cotaValor: '',
            cotaQuantidade: null,
            inicio: null,
            fim: null,
        },
        cotasAtribuidas: null,
        cotaAtribuida: null,
        cotaUnidade: 0,
        consumido: 0,
        cotaOld: null,
        checkHandleAlter: false,
        index: null,
        enums: {
            tipoCota,
            tipoUnidade,
        },
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
        verifyExame: null,
        verifyCota: null,
    }),
    watch: {
        'origem.cotaValor': function () {

            this.$refs.cotaValor.$el.getElementsByTagName('input')[0].value = this.origem.cotaValor

            this.unidade.cotaValor = this.origem.cotaValor
        },
        'origem.infraestruturaId': function () {

            this.unidadeDestino.unidadeId = null
            this.unidadeDestino.infraestruturaId = null

            this.resetUnidadeDestino()
        },
        'unidadeDestino.inicio': function () {

            this.unidadeDestino.fim = null
            this.verifyExame = null
            this.cotaUnidade = null

            if (this.unidadeDestino.inicio) {

                let cota = ''

                if (this.transferenciaLaboratorio) {

                    let cotasLaboratorio = ''

                    cotasLaboratorio = this.cotasLaboratorio.find(cota => cota.infraestruturaId == this.laboratorio.infraestruturaId)

                    if (cotasLaboratorio) {

                        cota = this.cotasLaboratorio
                            .find(field =>
                            field.infraestruturaId == this.laboratorio.infraestruturaId
                            && field.cotaTipoId == this.origem.cotaTipoId
                            && moment(

                                this.getFormatedDate(this.unidadeDestino.inicio, 'YYYY-MM-DD'),
                            )
                            .isBetween(
                                field.periodo.start.split("/").reverse().join("-"),
                                field.periodo.end.split("/").reverse().join("-"),
                                null,
                                '[]'
                            )
                        )

                        if (cota) {

                            this.cotaUnidade = cota.unidadeSolicitante.find(cota =>
                                cota.unidadeSolicitanteId == this.unidadeDestino.unidadeId
                                && cota.infraestruturaSolicitanteId == this.unidadeDestino.infraestruturaId)

                            cota.exames.map(cota => cota.unidadeSolicitante).forEach(exame => {

                                if(!this.verifyExame) {

                                    this.verifyExame = exame.find(unidadeSolicitante =>
                                        unidadeSolicitante.unidadeSolicitanteId == this.unidadeDestino.unidadeId
                                        && unidadeSolicitante.infraestruturaSolicitanteId == this.unidadeDestino.infraestruturaId
                                    )
                                }
                            });

                            if (this.cotaUnidade || this.verifyExame) {

                                this.unidadeDestino.fim = moment(
                                    cota.periodo.end,
                                    'DD/MM/YYYY'
                                ).toDate()
                            }
                        } else {

                            this.showValidationNotification(`Nenhuma cota encontrada para a data
                                ${this.getFormatedDate(this.unidadeDestino.inicio, 'DD/MM/YYYY')}.`)
                        }
                    } else {

                        this.showValidationNotification(`Nenhuma cota encontrada para a data
                            ${this.getFormatedDate(this.unidadeDestino.inicio, 'DD/MM/YYYY')}.`)
                    }

                } else {

                    let cotasUnidadeSolicitante = this.data.model.cotasUnidadeSolicitante.find(cota => cota.unidadeId == this.unidadeDestino.unidadeId
                        && cota.infraestruturaId == this.unidadeDestino.infraestruturaId)

                    if (cotasUnidadeSolicitante) {

                        cota = cotasUnidadeSolicitante.cotaUnidadeSolicitante
                            .find(field =>
                            field.cotaTipoId == this.origem.cotaTipoId
                            && moment(

                                this.getFormatedDate(this.unidadeDestino.inicio, 'YYYY-MM-DD'),
                            )
                            .isBetween(
                                field.periodo.start.split("/").reverse().join("-"),
                                field.periodo.end.split("/").reverse().join("-"),
                                null,
                                '[]'
                            )
                        )

                        if (cota) {

                            this.cotaUnidade = cota

                            this.unidadeDestino.fim = moment(
                                cota.periodo.end,
                                'DD/MM/YYYY'
                            ).toDate()
                        } else {

                            this.showValidationNotification(`Nenhuma cota encontrada para a data
                                ${this.getFormatedDate(this.unidadeDestino.inicio, 'DD/MM/YYYY')}.`)
                        }
                    } else {

                        this.showValidationNotification(`Nenhuma cota encontrada para a data
                            ${this.getFormatedDate(this.unidadeDestino.inicio, 'DD/MM/YYYY')}.`)
                    }
                }
            }
        }
    }
}
</script>